"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageCookie = void 0;
const cookie_1 = require("cookie");
const defaultOptions = {
    path: '/',
    maxAge: 60 * 60 * 24 * 30,
    domain: undefined,
    secure: true,
    sameSite: 'strict',
};
exports.StorageCookie = new (class {
    getCookies() {
        if (typeof document !== 'undefined') {
            return (0, cookie_1.parse)(document.cookie || '');
        }
        return {};
    }
    remove(key, options) {
        document.cookie = (0, cookie_1.serialize)(key, '', { ...defaultOptions, ...options, maxAge: 0 });
    }
    set(key, value, options) {
        document.cookie = (0, cookie_1.serialize)(key, value, { ...defaultOptions, ...options });
    }
    get(key) {
        const cookies = this.getCookies();
        return cookies[key] || undefined;
    }
    setNumber(key, value) {
        this.set(key, String(value));
    }
    getNumber(key) {
        const value = this.get(key);
        return value !== undefined ? Number(value) : undefined;
    }
    setBoolean(key, value) {
        this.set(key, String(value));
    }
    getBoolean(key) {
        const value = this.get(key);
        return value !== undefined ? value === 'true' : undefined;
    }
})();
